// official map style names of mapbox
// you can map.getStyle() and map.setStyle()
// DON'T IMPORT FROM HERE IN UI. THESE SHOULD BE IMPORTED BY src/map/map-constants.js
// and re-exported for consumption by the UI code
export const MAPBOX_DEFAULT_STYLE = 'Monochrome';
export const MAPBOX_SATELLITE_STYLE = 'Mapbox Satellite';

export const DEFAULT_FILL_OPACITY = 0.1;
export const DEFAULT_LINE_OPACITY = 0.2;

export const LAYERS = {
  PROPERTY_LIST: 'LAYERS.PROPERTY_LIST',
  PROPERTY_COUNT: 'LAYERS.PROPERTY_COUNT',
  CLUSTER: 'LAYERS.CLUSTER',
  CITY_BOUNDARY_FILL: 'LAYERS.CITY_BOUNDARY_FILL',
  CITY_BOUNDARY_LINE: 'LAYERS.CITY_BOUNDARY_LINE',
  ZONING_FILE_FILL: 'LAYERS.ZONING_FILE_FILL',
  ZONING_FILE_LINE: 'LAYERS.ZONING_FILE_LINE',
};

// Map dot colors happen in "src/map/layers.js"
export const DOT_COLORS = {
  isIdentified: '#37A3BC',
  isLicensed: '#37A3BC',
  unLicensed: '#E92329',
  isLiveWithoutAPN: '#FFC64A',
  fallback: '#90a4ae',
};
